package com.ives.modules;

import com.ives.modules.measurements.MeasurementInfo;

class Drawing {
	public static inline var SHAPE:String = "SHAPE";
	public static inline var CIRCLE:String = "CIRCLE";
	public static inline var RECTANGLE:String = "RECTANGLE";

	public var id:String;
	public var type:String;
	public var points:Array<Float>;
	public var handlePoints:Array<Float>;
	public var closed:Bool;
	public var showScale:Bool;
	public var inProgress:Bool;
	public var onModify:Drawing -> Void;
	public var event:ModuleEvent;
	public var color:String;

	public var measurementInfo:MeasurementInfo = new MeasurementInfo();

	public var lastHandleIndex:UInt;
	public var lastHandlePosition:Array<Float> = [];
	public var handles:Array<DrawingHandle> = [];

	public function new(type:String, points:Array<Float>, ?handlePoints:Array<Float>, id:String = '', color:String = "#0c4a6b", inProgress:Bool = false, closed:Bool = false, showScale:Bool = false, ?onModify:Drawing -> Void, ?event:ModuleEvent) {
		this.id = id;
		this.type = type;
		this.points = points;
		this.closed = closed;
		this.inProgress = inProgress;
		this.onModify = onModify;
		this.handlePoints = handlePoints;
		this.showScale = false;
		this.event = event;
		this.color = color;

		var index:UInt = 0;

		if (handlePoints == null)
			this.handlePoints = points;

		while (index < this.handlePoints.length) {
			handles.push(new DrawingHandle(this, index));

			index += 3;
		}
	}
}
